/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

// available field names for the Bulk asset form
export enum AssetBulkEditorFormFields {
  Groups = 'groups',
  AssetType = 'assetType',
  AssetCategory = 'assetCategory',
  Status = 'status',
  Schedule = 'schedule',
  MaintenanceSchedule = 'maintenanceSchedule',
  IoProfile = 'ioProfile',
  InstallDate = 'installDate',
  UninstallDate = 'uninstallDate',
  Make = 'make',
  Model = 'model',
  Year = 'year',
  Vin = 'vin',
  LicenseState = 'licenseState',
  FuelTankCapacity = 'fuelTankCapacity',
  FuelBurnRate = 'fuelBurnRate',
  OverrideOdometer = 'overrideOdometer',
  OverrideEngineRunTime = 'overrideEngineRunTime',
  OverrideSpeed = 'overrideSpeed',
  OdometerReferenceUnit = 'odometerReferenceUnit',
  Driver = 'operators'
}

// available field names for the Bulk asset form
export enum AssetMoveEditorFormFields {
  Groups = 'groups'
}

// available field names for the Bulk device move form
export enum DeviceMoveEditorFormFields {
  Account = 'account'
}

// available field names for the Bulk Group form
export enum GroupFormFields {
  Status = 'status',
  UnitOfMeasure = 'unitOfMeasure',
  AutoAssetCreation = 'autoAssetCreationEnabled',
  AutoAssetAssociation = 'autoAssetAssociationEnabled',
}

// available field names for the Bulk User form
export enum UserBulkEditorFormFields {
  Status = 'status',
  UOM = 'uom'
}

// available field names for the Bulk user form
export enum UserMoveEditorFormFields {
  Groups = 'groups'
}

// available field names for the Bulk Operator form
export enum DeviceBulkEditorFormFields {
  Groups = 'groups',
  Status = 'status',
  DeviceType = 'type',
  DeviceConfiguration = 'deviceConfiguration',
  ShipDate = 'shipDate'
}

// available field names for the Bulk Operator form
export enum OperatorBulkEditorFormFields {
  Status = 'status',
  Type = 'type',
  OperatorCategory = 'operatorCategory'
}

// the mode of the editor while it opened...
export enum EditorMode {
  Hide = 'hide',
  View = 'view',
  Add = 'add',
  Edit = 'edit',
  Clone = 'clone'
};

// the logical position of the HTML element...
export enum LogicalPosition {
  Start = 'start',
  Center = 'center',
  End = 'end',
  Nearest = 'nearest'
}
